import _jsx from "@babel/runtime-corejs3/helpers/esm/jsx";

var _View;

/*
 * Copyright (C) 2019 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
import React, { useState } from 'react';
import { func, string, number } from 'prop-types';
import { DraggableCore } from 'react-draggable';
import keycode from 'keycode';
import { View } from '@instructure/ui-view';
import { IconDragHandleLine } from '@instructure/ui-icons';
import DraggingBlocker from './DraggingBlocker';
import formatMessage from '../format-message';
const RESIZE_STEP = 16;
export default function ResizeHandle(props) {
  const [dragging, setDragging] = useState(false); // tracking isFocused rather than leveraging instui Focusable
  // because Focusable doesn't detect whan ResizeHandle gets focus

  const [isFocused, setIsFocused] = useState(false);
  return /*#__PURE__*/_jsx(View, {
    "aria-label": formatMessage('Drag handle. Use up and down arrows to resize'),
    title: formatMessage('Resize'),
    as: "span",
    borderRadius: "medium",
    display: "inline-block",
    withFocusOutline: isFocused,
    padding: "0 xx-small",
    position: "relative",
    role: "button",
    "data-btn-id": props['data-btn-id'],
    tabIndex: props.tabIndex,
    onKeyDown: function (event) {
      if (event.keyCode === keycode.codes.up) {
        event.preventDefault();
        event.stopPropagation();
        props.onDrag(event, {
          deltaY: -16
        });
      } else if (event.keyCode === keycode.codes.down) {
        event.preventDefault();
        event.stopPropagation();
        props.onDrag(event, {
          deltaY: RESIZE_STEP
        });
      }
    },
    onFocus: function (event) {
      var _props$onFocus;

      setIsFocused(true);
      (_props$onFocus = props.onFocus) === null || _props$onFocus === void 0 ? void 0 : _props$onFocus.call(props, event);
    },
    onBlur: function () {
      setIsFocused(false);
    }
  }, void 0, /*#__PURE__*/_jsx(DraggableCore, {
    offsetParent: document.body,
    onDrag: props.onDrag,
    onStart: function () {
      setDragging(true);
    },
    onStop: function () {
      setDragging(false);
    }
  }, void 0, _View || (_View = /*#__PURE__*/_jsx(View, {
    cursor: "ns-resize"
  }, void 0, /*#__PURE__*/_jsx(IconDragHandleLine, {})))), /*#__PURE__*/_jsx(DraggingBlocker, {
    dragging: dragging
  }));
}
ResizeHandle.defaultProps = {
  onDrag: () => {},
  tabIndex: -1
};